import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const ownerGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  const userJson = localStorage.getItem('CURRENT_USER');
  let role = authService.userRole();
  
  if (!role && userJson) {
    try {
      const user = JSON.parse(userJson);
      role = user.role;
      // If we found a role in storage, manually sync the signal for the rest of the app
      authService.currentUser.set(user);
    } catch (e) {}
  }

  const normalizedRole = (role || '').toUpperCase();
  const isAuthorized = ['OWNER', 'STAFF', 'SUPER_ADMIN'].includes(normalizedRole);

  console.log(`[OwnerGuard] Role: ${normalizedRole}, Authorized: ${isAuthorized}`);

  if (isAuthorized) {
    const currentUser = authService.currentUser();
    if ((normalizedRole === 'OWNER' || normalizedRole === 'STAFF') && (!currentUser || !currentUser.cafeId)) {
      console.warn(`[OwnerGuard] User has no cafe setup. Redirecting to /setup`);
      router.navigate(['/setup']);
      return false;
    }
    return true;
  }

  console.warn(`[OwnerGuard] Access denied. Redirecting to login.`);
  router.navigate(['/auth/login']);
  return false;
};
